import PropTypes from 'prop-types';
import clsx from 'clsx';

import { useMemo } from 'react';
import CustomCheckbox from '@components/shared/CustomCheckbox';
import ThreeDotsDropdown from '@components/ThreeDotsDropdown';
import Form from '@assets/icons/form.svg';
import DownloadIcon from '@assets/icons/download.svg';
import CustomText from '@components/shared/CustomText';
import { formatDocViewerDate } from '@shared/helpers/format';
import styles from './MobileRow.module.scss';
import { SIGNATURE_TYPE } from '../../constants';

const MobileRow = ({
  item,
  rowCheckbox,
  onDownload,
  handleItemClick,
  dropdownItems,
  isSelected,
  onSelect,
}) => {
  const updatedItems = useMemo(
    () => [
      {
        value: 'Download',
        icon: <DownloadIcon width={16} />,
        onClick: onDownload,
      },
      ...dropdownItems,
    ],
    [dropdownItems, onDownload],
  );
  return (
    <div className={styles.row} onClick={() => onSelect(rowCheckbox)}>
      <div className={styles.rowContent}>
        <div className={styles.topFlex}>
          <div className={styles.formCheckbox}>
            <CustomCheckbox checked={isSelected} readOnly small />
            <Form className={styles.icon} />
            <CustomText customStyle={clsx('body1', 'ellipsis')}>
              {item?.form_name}
            </CustomText>
          </div>

          <ThreeDotsDropdown items={updatedItems} onSelect={handleItemClick} />
        </div>
        <div className={styles.bottomFlex}>
          <div>
            <CustomText customStyle={'subtitle2'}>Signing Date</CustomText>
            <CustomText customStyle={'body2'}>
              {formatDocViewerDate(new Date(item?.date))}
            </CustomText>
          </div>
          <div>
            <CustomText customStyle={'subtitle2'}>Type of consent</CustomText>
            <CustomText customStyle={'body2'}>
              {SIGNATURE_TYPE[item?.signature_type]}
            </CustomText>
          </div>
        </div>
      </div>
    </div>
  );
};

MobileRow.propTypes = {
  item: PropTypes.shape({
    user_id: PropTypes.string,
    date: PropTypes.string,
    form_name: PropTypes.string,
    signature_type: PropTypes.string,
    signed_doc_url: PropTypes.string,
  }),
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  rowCheckbox: PropTypes.string,
  onDownload: PropTypes.func,
  handleItemClick: PropTypes.func,
  dropdownItems: PropTypes.array,
};

export default MobileRow;
